var React = require('react');

function CheckCircleOutline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19 3.16666C10.26 3.16666 3.16663 10.26 3.16663 19C3.16663 27.74 10.26 34.8333 19 34.8333C27.74 34.8333 34.8333 27.74 34.8333 19C34.8333 10.26 27.74 3.16666 19 3.16666ZM19 31.6667C12.0175 31.6667 6.33329 25.9825 6.33329 19C6.33329 12.0175 12.0175 6.33332 19 6.33332C25.9825 6.33332 31.6666 12.0175 31.6666 19C31.6666 25.9825 25.9825 31.6667 19 31.6667ZM26.2675 12.0017L15.8333 22.4358L11.7325 18.3508L9.49996 20.5833L15.8333 26.9167L28.5 14.25L26.2675 12.0017Z","fill":"#382E2B"}));
}

CheckCircleOutline.defaultProps = {"width":"38","height":"38","viewBox":"0 0 38 38","fill":"none"};

module.exports = CheckCircleOutline;

CheckCircleOutline.default = CheckCircleOutline;
